import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DealRentSendSimilarModal } from './DealRentSendSimilarModal';
import { selectDealRent, selectOfferId } from '../../selectors';
import { closeSendSimilar, sendFormToSimilarOfferAction as sendFormAction } from '../../store/deal-rent';
import { trackSafeRentSimilarFormClick } from '../../store/deal-rent/tracking';

export const DealRentSendSimilarModalContainer: React.VFC = () => {
  const dispatch = useDispatch();
  const { isSendSimilarModal } = useSelector(selectDealRent);
  const offerId = useSelector(selectOfferId);

  const onCloseModal = React.useCallback(() => {
    trackSafeRentSimilarFormClick();
    dispatch(closeSendSimilar());
  }, [dispatch]);

  const onSendForm = React.useCallback(val => dispatch(sendFormAction(val)), [dispatch]);

  return (
    <DealRentSendSimilarModal
      offerId={offerId}
      isOpen={isSendSimilarModal}
      closeModal={onCloseModal}
      sendForm={onSendForm}
    />
  );
};
